import IconCheckRounded from "@simble/shared/assets/icons/check-rounded-ico.svg?react";
import IconClose from "@simble/shared/assets/icons/close-ico.svg?react";
import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";

export const Toaster = () => <SonnerToaster closeButton position="top-right" />;

export type ToastProps = {
  title: string;
  description?: string;
  button?: { label: string; onClick: () => void };
  id: string | number;
  className?: string;
};

const DEFAULT_TOAST_CLASS = "px-4 py-3";

export const Toast = (props: ToastProps) => {
  const { title, className, id } = props;

  return (
    <div className={className || DEFAULT_TOAST_CLASS} role="alert">
      <div className="flex w-[354px] items-center justify-between rounded-[12px] bg-[#DEFFE3] p-[12px]">
        <div className="flex items-center gap-[8px]">
          <IconCheckRounded className="mt-0.5 size-5 min-w-5 text-accent" />
          <p className="body-regular font-normal text-[16px] text-accent">{title}</p>
        </div>

        <button
          className="cursor-pointer"
          onClick={() => {
            sonnerToast.dismiss(id);
          }}
          type="button"
        >
          <IconClose className="mt-0.5 size-5 min-w-5 text-icon-default" />
        </button>
      </div>
    </div>
  );
};

export const toast: typeof sonnerToast = sonnerToast;

// const INFINITE_DURATION = Number.POSITIVE_INFINITY;

export const showToast = (props: Omit<ToastProps, "id">) => {
  sonnerToast.custom((id) => <Toast id={id} {...props} />, { duration: 3000 });
};
